import { render, staticRenderFns } from "./NavigationTypeView.vue?vue&type=template&id=49295122&scoped=true"
import script from "./NavigationTypeView.vue?vue&type=script&lang=js"
export * from "./NavigationTypeView.vue?vue&type=script&lang=js"
import style0 from "./NavigationTypeView.vue?vue&type=style&index=0&id=49295122&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49295122",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49295122')) {
      api.createRecord('49295122', component.options)
    } else {
      api.reload('49295122', component.options)
    }
    module.hot.accept("./NavigationTypeView.vue?vue&type=template&id=49295122&scoped=true", function () {
      api.rerender('49295122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/availableSpaces/components/NavigationTypeView.vue"
export default component.exports